import React, { useContext, useState } from "react";
import { Form } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import SaveIcon from "../../Icons/SaveIcon";
import {
  getFormComponent,
  getPhoneNoFormComp,
  processFormData,
} from "../../helpers/formHandlers";
import useToast from "../../hooks/useToast";
import { editUserProfile } from "../../api/user";
import { Toast } from "../../Components/Toast/Toast";
import { AuthContext } from "../../Context/AuthContext";
import FormSubmissionBttn from "../../Components/Buttons/FormSubmissionBttn";

const formStyle = css`
  padding: 2vh 4vh 3vh;
  gap: 2.5vh;
  align-items: center;
`;

const EditUserForm = ({
  attrName = "",
  formProps = [],
  setPopUp,
  showParentToast,
}) => {
  const [formData, setForm] = useState(formProps);
  const { toast, showToast, hideToast } = useToast();
  const { logout } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const processedData = processFormData(formData);
    if (processedData.errors === true) {
      return showToast({
        title: `${processedData.formErrors[0].label} error`,
        text: `${processedData.formErrors[0].errors}`,
        type: "Error",
        hidden: false,
      });
    }
    console.log("processedData", processedData);
    try {
      await editUserProfile(processedData);
      setPopUp({ isOpen: false, component: null });
      showParentToast({
        type: "Success",
        title: "Success",
        text: "Your details were updated successfully.",
        hidden: false,
      });
    } catch (error) {
      setPopUp({ isOpen: false, component: null });
      if (error.status === 401) {
        logout();
      }
      return showToast({
        title: "Unexpected error",
        text: `${error.message}`,
        type: "Error",
        hidden: false,
      });
    }
  };

  return (
    <Form $baseStyle={formStyle} onSubmit={(e) => handleSubmit(e)}>
      {!toast.hidden && (
        <Toast
          message={toast.text}
          title={toast.title}
          type={toast.type}
          hideToast={hideToast}
        />
      )}
      {attrName === "Phone number"
        ? getPhoneNoFormComp(formData[0], formData[1], setForm, 0, 1)
        : formData.map((props, index) =>
            getFormComponent({ props, setForm, index })
          )}
      <FormSubmissionBttn text={"Save"} icon={<SaveIcon/>}/>
    </Form>
  );
};

export default EditUserForm;
